//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../Features/Features.FaceRecognitionBuilder.js";
import "../no/SelectTaggedObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"Axis",1,"Axis",0],[1,"CircularCount",0,"Expression",0],[1,"Face",0,"ScCollector",0],[1,"FaceRecognized",0,"Features.FaceRecognitionBuilder",0],[1,"Plane",0,"SelectTaggedObject",0],[0,"RestoreOption",1,0],[0,"Type",1,0],[1,"XCount",0,"Expression",0],[1,"XDistance",0,"Expression",0],[0,"XVector",1,"Direction",0],[1,"YCount",0,"Expression",0],[1,"YDistance",0,"Expression",0],[0,"YVector",1,"Direction",0]],[],[]];
SPLM.Features.PatternFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PatternFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PatternFaceBuilder.PatternTypes = Object.freeze({
    "Rectangular" : "Rectangular", "Circular" : "Circular", "Mirror" : "Mirror"});

export default SPLM;